/**
 * DisplayItem > Assets object.
 *
 * @typedef {Object} Assets
 * @namespace
 *
 * @memberof Common.Model.Entity.DisplayItem
 *
 * @property {String} main String defining the asset ref for the large/main image.
 * @property {String} thumbnail String defining the asset ref for the small/thumbnail image.
 * @property {String} background String defining the asset ref for the background image (haven't seen this used before!).
 */
class Assets {
  constructor(main, thumbnail, background, sizes) {
    this.main = main;
    this.thumbnail = thumbnail;
    this.background = background;
    this.sizes = sizes;
  }
}

export default Assets;
